<div class="column">
  <div>
    <button mat-button *ngIf="!disabeled &&  sliderPicture.length<=4"
      (click)="$event.preventDefault();pictureSliderClick()" type="button"
      class="btn btn-info text-white px-5 mx-3 mt-3">
      افزودن عکس
    </button>
  </div>
  <small class="warning">* سایز عکس‌های اسلایدر باید 331 * 588 پیکسل باشد</small>
  <div style="width: 550px;">
    <swiper *ngIf="sliderPictureBase64.length || sliderPicture.length" [config]="config" [(index)]="index">
      <div *ngFor="let item of sliderPictureBase64;index as i">
        <img height="350px" width="100%" [src]="item" alt="">
        <button color="primary" mat-Raised-button mat-button *ngIf="!disabeled && sliderPictureBase64.length"
          (click)="removeBase64Picture(i)" type="button">
          حذف
        </button>
      </div>
      <div *ngFor="let item of sliderPicture;index as i">
        <img height="350px" width="100%" [src]="item.imgUrl" alt="">
        <button color="primary" mat-Raised-button mat-button *ngIf="!disabeled && sliderPicture.length"
          (click)="removePicture(i)" type="button">
          حذف
        </button>
      </div>
    </swiper>
  </div>
</div>
<input #fileMulti [style.display]="'none'" accept="image/*" multiple (change)="onPictureSliderAdded($event)"
  type="file">
